import React, { useState } from "react";
import { useRouteMatch } from "react-router-dom";

import { GET_POSTS } from 'graphql/query/post-gql';

import Post from 'components/post';
import User from 'components/user';
import { useActiveMenuItem, useBreadCrumbs } from "components/use-hooks";
import { Tables } from "components/layout";
import { Localize } from "components/service";
import { gqlBuilderWhere } from "utils";




const UserPostSubPage = ({ user }) => {


    const basePath = User.Const.basePath;
    const postBasePath = Post.Const.basePath;
    const tableHelper = Post.Helpers.TableMain([ 'author' ]);

    useActiveMenuItem([ "users" ], [ "users" ]);


    const breadcrumbs = [
        {
            label: Localize({ children: "BREADCRUMBS.Label_Users" }).props.children,
            path: `${ basePath }`
        },
        {
            label: user?.name,
            path: `${ basePath }/${ user?.id }`
        },
        {
            label: Localize({ children: "BREADCRUMBS.Label_Posts" }).props.children,
            path: `${ basePath }/${ user?.id }${ postBasePath }`
        }
    ]

    useBreadCrumbs(breadcrumbs);

    const routeUrl = `${ basePath }/${ user?.id }${ postBasePath }`;
    let match = useRouteMatch(`${ routeUrl }/page/:pageNum`);

    const objOrderBy = [ { column: "CREATED_AT", order: "DESC" } ];

    const [ searchText, setSearchText ] = useState("");
    const [ filters, setFilters ] = useState();
    const [ resetSorting, setResetSorting ] = useState(false);

    const modelFilters = `postsFilters_userID-${ user?.id }`;
    const modelSorting = `postsSorting_userID-${ user?.id }`;

    const postsFilters = JSON.parse(localStorage.getItem(modelFilters));
    const postsSorting = JSON.parse(localStorage.getItem(modelSorting));


    return (

        <Tables.Main
            model="posts"
            extraClass="table-posts"
            query={ GET_POSTS }
            varSet={ { perPage: 30, type: 'USER', id_type: user?.id } }
            routeUrl={ routeUrl }
            currentPage={ match ? parseInt(match.params.pageNum) : 1 }
            searchText={ searchText }
            objFilter={ filters || gqlBuilderWhere(postsFilters) }
            objOrderBy={ postsSorting || objOrderBy }
            sortingName={ modelSorting }
            tableHelper={ tableHelper }
            resetSorting={ resetSorting }
            totalCounter={ true }
        >
            <div className="table-action-bar">

                <div className="col">
                    <Post.Filters.Table
                        formFieldsHide={ [ 'AUTHOR_ID' ] }
                        filters={ filters }
                        setSearchText={ setSearchText }
                        setFilters={ setFilters }
                        postsFilters={ postsFilters }
                        setResetSorting={ setResetSorting }
                        objOrderBy={ objOrderBy }
                        modelFilters={ modelFilters }
                        modelSorting={ modelSorting }
                    />
                </div>

                <div className="col"> </div>
            </div>
        </Tables.Main>
    )
};

export default UserPostSubPage;